import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_COMMON from "./KAMPYLE_COMMON";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_TARGETING from "./KAMPYLE_TARGETING";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_VIEW from "./KAMPYLE_VIEW";
import MDIGITAL_ELEMENT_BUILDER from "./MDIGITAL_ELEMENT_BUILDER";
import MDIGITAL_FORM_STATE from "./MDIGITAL_FORM_STATE";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import MDIGITAL_PROPERTY_MESSAGES from "./MDIGITAL_PROPERTY_MESSAGES";

  var DEFAULTS = {
    CORNER_MARGIN: 0,
    TRIANGULAR_MARGIN: 0,
    VERTICAL_MARGIN: 30,
  };
  var BUTTON_FUNCTION_ENUM = {
    vertical: 'getVerticalButton',
    triangular: 'getTriangularButton',
    custom: 'getCustomButton',
  }
  var boundHandleLoadCustomBtnEvent;
  function handleInviteReady(eventName, data) {
    data = data || {};
    if(KAMPYLE_FUNC.hasApplicationLoadingFailed(data.formId,true)){
      return;
    }
    var inviteContainer = document.getElementById('kampyleInviteContainer');
    if (newMobileInvite()) {

      restoreHostingDOM();
      if (inviteContainer) {
        var isMobileWebBannerFixEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.MOBILE_WEB_BANNER_FIX);

        KAMPYLE_UTILS.setElementStyle(inviteContainer, {
          top: '',
          bottom: '',
          left: '',
          right: '',
          background: 'none',
          visibility: isMobileWebBannerFixEnabled ? 'hidden' : '',
          display: isMobileWebBannerFixEnabled ? '' : 'none',
        }, true /* important */);
      }
    }
    else { //This could happen for old invite version with good provisions
      KAMPYLE_UTILS.setElementStyle(inviteContainer, {
        visibility: 'visible',
      }, true /* important */);
      var iframe = document.getElementById('kampyleInvite');
      if (iframe) {
        KAMPYLE_UTILS.setElementStyle(iframe, {
          visibility: 'visible',
        }, true /* important */);
      }
    }
  }

  function onKeyboardClose(e) {
    KAMPYLE_UTILS.showInvite();
    KAMPYLE_UTILS.removeEventHandler(e.srcElement, 'blur', onKeyboardClose);
  }

  function onKeyboardOpen(e) {
    KAMPYLE_UTILS.hideInvite();
    //setup listener to show the invitation again after the keyboard is closed
    KAMPYLE_UTILS.setEventHandler(e.srcElement, 'blur', onKeyboardClose);
  }

  function getAllFocusableElements() {
    var inputs = document.querySelectorAll('input');
    var textarea = document.querySelectorAll('textarea');
    var allFocusableElements = [];
    var i;

    for (i = 0; i < inputs.length; i++) {
      allFocusableElements.push(inputs[i]);
    }

    for (i = 0; i < textarea.length; i++) {
      allFocusableElements.push(textarea[i]);
    }

    return allFocusableElements;
  }


  function setupListenersForHideInviteWhenVirtualKeyboardIsOpen(eventName, data) {
    data = data || {};
    data.formId = data.formId || KAMPYLE_DATA.getMemoryData('currentFormId');

    var pos = KAMPYLE_VIEW.getInvitePosition(data.formId);
    if (newMobileInvite() && pos === 'bottom') {
      var allFocusableElements = getAllFocusableElements();
      for (var i = 0; i < allFocusableElements.length; i++) {
        KAMPYLE_UTILS.setEventHandler(allFocusableElements[i], 'focus', onKeyboardOpen);
      }
    }
  }

  function removeListenersForHideInviteWhenVirtualKeyboardIsOpen(eventName, data) {
    data = data || {};
    data.formId = data.formId || KAMPYLE_DATA.getMemoryData('currentFormId');

    var pos = KAMPYLE_VIEW.getInvitePosition(data.formId);
    if (newMobileInvite() && pos === 'bottom') {
      var allFocusableElements = getAllFocusableElements();
      for (var i = 0; i < allFocusableElements.length; i++) {
        KAMPYLE_UTILS.removeEventHandler(allFocusableElements[i], 'focus', onKeyboardOpen);
      }
    }
  }
  // Make sure we don't pop up invite more than once
  function showInviteIfNeeded(eventName, params) {
    var shouldShowParamName = KAMPYLE_TARGETING.generateShouldShowInviteParamName(params.formId);
    var shouldShowInvite = KAMPYLE_DATA.getMemoryData(shouldShowParamName);
    if (shouldShowInvite) {
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_invitation_loaded', { formId: params.formId });
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_showInvitation', { formId: params.formId });
      KAMPYLE_DATA.deleteMemoryData(shouldShowParamName);
    }
  }

  function scrollToEmbeddedForm(formId){
    document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + formId).scrollIntoView();
  }

  function doScrollY(numOfPixels) {
    window.scrollTo(0, numOfPixels);
  }

  function scrollToTop(eventName, data) {
    data = data || {};
    if (!KAMPYLE_DATA.isEmbeddedDisplayType(data.formId)){
      doScrollY(0);
    }
  }

  function scrollFromTop(eventName, data) {
    var pixelsToScroll = (data || {}).numberOfPixels || 0; // y position of the required field

    // Fix for EEQ-7769: when trying to submit with an empty required field in embedded form,
		// first we need to scroll to the top of the form and then to the field itself.
    if(KAMPYLE_DATA.isEmbeddedDisplayType(data.formId)){
      scrollToEmbeddedForm(data.formId);
      var scrollY = (KAMPYLE_UTILS.getScrollPosition() || {}).y || 0;
      KAMPYLE_VIEW.doScrollY(pixelsToScroll +  scrollY);
    }
		// In non-embedded forms, we are already positioned at the top of the form.
    else{
      KAMPYLE_VIEW.doScrollY(pixelsToScroll);
    }
  }

  function hideSpinnerIfPopup (eventName, data) {
    if(KAMPYLE_DATA.isPopupDisplayType(data.formId)) {
      hideSpinner();
    }
  }

  function handleInvitationSkippedForms(eventName, data) {
    if (KAMPYLE_DATA.getData('isSkipInvitationOptimized') !== 'true') {
      return;
    }

    KAMPYLE_UTILS.setElementStyle(document.getElementById('kampyleFormContainer'), {
      visibility: 'visible',
    }, true);

    KAMPYLE_VIEW.prepareHostingDOM();

    KAMPYLE_DATA.setData('isSkipInvitationOptimized', false);
  }

  function init() {
    var eventMapping = {
      neb_targetingInit: [removeAllShownElements],
      neb_loadInvitation: [createInviteIframe],
      neb_loadForm: [handleLightBoxIframe, showSpinner, applyMobileDynamicStyles],
      neb_formReady: [hideButton], //TODO - check if button was previously shown
      neb_formLoaded: [setIframeOrigin, hideSpinner, showInviteIfNeeded], // showInviteIfNeeded -> We only want to display invite after form is loaded
      neb_formShown: [handleInvitationSkippedForms],
      neb_inviteHeightChanged: [changeInviteHeight],
      neb_iFrameHeightChanged: [reactToIframeHeightChange],
      neb_scrollToTop: [scrollToTop],
      neb_scrollFromTop: [scrollFromTop],
      neb_inviteReady: [handleInviteReady, setupListenersForHideInviteWhenVirtualKeyboardIsOpen],
      neb_scrollToForm: [scrollToForm],
      neb_showButton: [showButton, alignButtonWithForm, setVerticalPosition, listenToResize],
      neb_buttonClicked:[handleButtonClicked],
      neb_sdkShowForm: [hideButton],
      neb_captureInit: [hideVisibility, hideButton],
      neb_inviteAccepted: [hideInvite, hideButton, removeListenersForHideInviteWhenVirtualKeyboardIsOpen],
      neb_showForm: [showForm],
      neb_sdkPageView: [hideInvite, removeListenersForHideInviteWhenVirtualKeyboardIsOpen],
      neb_inviteDeclined: [hideInvite, removeListenersForHideInviteWhenVirtualKeyboardIsOpen],
      neb_formClosed: [hideForm], //Showing the button from KAMPYLE_FUNC
      neb_popupBlocked: [hideForm],
      neb_formHide: [hideVisibility],
      neb_captureImageClicked: [showVisibility],
      MDigital_Capture_Cancelled: [showVisibility],
      neb_formLoadingHasFailed: [showFormCouldNotFechtedErrorMsg],
      neb_inviteLoaded: [hideSpinnerIfPopup],
      MDigital_Invalid_Origin: [showFormCouldNotFechtedErrorMsg],
    };

    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ADDITIONAL_BUTTON_STYLES)){
      eventMapping.neb_showButton.push(setZIndex);
    }


    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
    if(!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CSP_RULES)){
      KAMPYLE_UTILS.addStyle('.noOutline{outline: none !important;}');
      KAMPYLE_UTILS.addStyle('.wcagOutline:focus{outline: 1px dashed #595959 !important;outline-offset: 2px !important;transition: none !important;}');
    }

    KAMPYLE_UTILS.setEventHandler(window, 'resize', function(e) {
      updateIframeStyle();
    });
    KAMPYLE_DATA.setMemoryData('isOriginalHostingDom', true);
  }

  function toggleSpinner(isShow) {
    var display = isShow ? 'block' : 'none';
    var spinners = document.getElementsByClassName('neb-loading-spinner');
    if (spinners && spinners.length) {
      for (var i = spinners.length - 1; i >= 0; i--) {
        KAMPYLE_UTILS.setElementStyle(spinners[i], { display: display });
      }
    }
  }

  function toggleButtonVisibility(shouldShow) {
    var buttonEl = document.getElementById('nebula_div_btn');
    if (!buttonEl) {
      return;
    }
    var visibility = shouldShow ? 'visible' : 'hidden';
    KAMPYLE_UTILS.setElementStyle(buttonEl, { visibility: visibility }, false);
  }

  function shouldAdjustToZoom(formData) {
    return formData && KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion');
  }

  function listenToResize(eventName, data) {
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    if (!shouldAdjustToZoom(formData)) {
      return;
    }

    function resizeButtonBasedOnText() {
      // Clear cached zoom to bypass the "unchanged zoom" check in onResizeButton and force repositioning
      KAMPYLE_DATA.deleteMemoryData('kampylePageZoom');
      onResizeButton(formData);
      toggleButtonVisibility(true);
    }

    var debouncedForceReposition = KAMPYLE_UTILS.debounce(resizeButtonBasedOnText, 150, false);

    var buttonTextElm = document.querySelector('.kampyle_button-text');
    if (buttonTextElm) {
      new ResizeObserver(function () {
          toggleButtonVisibility(false);
          debouncedForceReposition();
      }).observe(buttonTextElm);
    }
    KAMPYLE_UTILS.setEventHandler(window, 'resize', debouncedOnResize(formData));
  }

  function debouncedOnResize(formData) {
    var shouldBeImmediate = !KAMPYLE_DATA.isMobile();
    var onResizeWithFormData = KAMPYLE_VIEW.onResizeButton.bind(null, formData);
    var debounced = KAMPYLE_UTILS.debounce(onResizeWithFormData, 100, shouldBeImmediate);
    KAMPYLE_VIEW.debouncedOnResize = debounced;
    return debounced;
  }

  function onResizeButton(formData) {
    var z = KAMPYLE_UTILS.getZoomedIn();
    var currentZoom = z.zoom;
    var wasZoomUnchanged = currentZoom && currentZoom === KAMPYLE_DATA.getMemoryData('kampylePageZoom');
    if (wasZoomUnchanged) {return;}
    KAMPYLE_DATA.setMemoryData('kampylePageZoom', currentZoom);
    var btnStaticData = {
      buttonVerticalOffset: KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.verticalOffset') || 0,
      buttonType: KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.type') || '',
      buttonPosition: getButtonDirection(formData),
    }
    if (btnStaticData.buttonType === 'custom') {
      var imgElement = document.querySelector('#nebula_div_btn > img');
      handleLoadCustomBtnEvent(imgElement, btnStaticData);
    } else {
      resizeButton(btnStaticData, formData);
      setVerticalPosition('windowResize', btnStaticData);
    }
  }

  function unlistenToResize() {
    KAMPYLE_UTILS.removeEventHandler(window, 'resize', KAMPYLE_VIEW.debouncedOnResize);
  }

  function hideSpinner(eventName, data) {
    toggleSpinner(false);
  }

  function showSpinner(eventName, data) {
    toggleSpinner(true);
  }

  function scrollToForm(eventName, data) {
    document.getElementById('kampyleFormContainer').scrollIntoView();
    // window.setTimeout(function() {
    //   document.getElementById('kampyleFormContainer').scrollIntoView();
    // }, 200);
  }

  function getCornerMargin(formData) {
    formData = formData || {};
    var isInvite = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'formType') === 'invitation';
    var margin;

    //If invite -> get default margin
    if (!isInvite) { //Button
      var buttonType = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.type');

      //If custom image -> take corner margin property
      //If regular button -> get its left margin
      switch (buttonType) {
        case 'vertical':
        case 'triangular':
        margin = DEFAULTS.TRIANGULAR_MARGIN;
        break;
        case 'custom':
        margin = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.cornerMargin') || DEFAULTS.CORNER_MARGIN;
        break;
        default:
        margin = DEFAULTS.CORNER_MARGIN;
        break;
      }

    }
    else { //Invite
      margin = DEFAULTS.CORNER_MARGIN;
    }

    return parseInt(margin, 10);
  }


  function getButtonDirection(formData) {
    formData = formData || {};

    return KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.position') || 'right';

  }
  function alignButtonWithForm(eventName, data) {
    data = data || {};

    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var buttonContainer = document.getElementById('nebula_div_btn');
    if (!buttonContainer || !formData) { return false; }

    var cornerMargin = getCornerMargin(formData) + 'px';

    switch (getButtonDirection(formData)) {
      case 'bottomRight':
      buttonContainer.style.right = cornerMargin;
      break;
      case 'bottomLeft':
      buttonContainer.style.left = cornerMargin;
      break;
      default:
      break;
    }
  }

  function setVerticalPosition(eventName, data) {
    var offset = 0;
    var buttonWidth = 35;
    var position = '';
    var buttonType = '';
    var formData = (data && data.formId && KAMPYLE_DATA.getFormData(data.formId)) || {};
    if (eventName === 'windowResize') {
      offset = data.buttonVerticalOffset;
      position = data.buttonPosition;
      buttonType = data.buttonType;
    } else {
      var buttonData = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData');
      offset = KAMPYLE_UTILS.getNestedPropertyValue(buttonData, 'verticalOffset') || 0;
      position = buttonData.position;
      buttonType = KAMPYLE_UTILS.getNestedPropertyValue(buttonData, 'type');
    }
    if (buttonType === 'custom') {
      // This function doesn't fit 'custom' buttons, which need to style according img height
      return;
    }
    var shouldAdjustToZoom = eventName === 'windowResize' || KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion');

    if (!isNaN(offset)) {
      var nebButton = document.getElementById('nebula_div_btn');
      if (nebButton && nebButton.style) {
        if (shouldAdjustToZoom) {
          var z = KAMPYLE_UTILS.getZoomedIn();
          offset = Number(offset) / z.zoom;
          if (z.isZoomedIn) {
            buttonWidth = buttonWidth * (z.constraint/z.zoom);
          }
        }
        if (position.indexOf('bottom') > -1) {
          nebButton.style.marginBottom = offset + 'px';
        } else if (position.indexOf('top') > -1) {
          offset = Number(offset) * -1;
          nebButton.style.marginTop = offset + 'px';
        } else {
          offset = Number(offset);
          nebButton.style.bottom = window.innerHeight * 0.55 - buttonWidth + offset + 'px';
        }
      }
    }
  }

  function setZIndex(eventName, data) {
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var zIndex = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.zIndex');
    if (KAMPYLE_UTILS.isValueNumericAndDefined(zIndex)) {
      var nebButton = document.getElementById('nebula_div_btn');
      nebButton.style.zIndex = zIndex;
    }
  }

  function showVisibility(eventName, data) {
    var currentFormId = KAMPYLE_DATA.getMemoryData('currentFormId');
    var formData = KAMPYLE_DATA.getFormData(currentFormId);

    if (KAMPYLE_DATA.getDisplayType(formData) === 'animation') { return false; }


    var formContainer = document.getElementById('kampyleFormContainer');
    var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + currentFormId);
    if (!!formContainer && !!formIframe)
    {
      KAMPYLE_UTILS.setElementStyle(formContainer, {
        display: 'block',
        visibility: 'visible',
      }, true);
    }

  }

  function getWCAGClass() {
    return KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.WCAG) ? ' wcagOutline ' : ' noOutline ';
  }

  function hideVisibility() {
    var currentFormId = KAMPYLE_DATA.getMemoryData('currentFormId');
    if (!currentFormId) {return;}

    var formContainer = document.getElementById('kampyleFormContainer');
    var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + currentFormId);
    var noDataContainer = document.getElementById("mdigital-no-json-modal_"+currentFormId);
    if (!!formContainer && (!!formIframe || !!noDataContainer))
    {
      KAMPYLE_UTILS.setElementStyle(formContainer, {
        display: 'none',
        visibility: 'hidden',
      }, true);

    }
  }

  function hideForm(eventName, data) {
    data = data || {};
    var currentFormId =  KAMPYLE_DATA.getMemoryData('currentFormId');

    setMetaViewport('remove');
    var kampyleFormContainer = document.getElementById('kampyleFormContainer');
    if (kampyleFormContainer !== null) {

      //when closing form reload iframe inorder to get clean form
      var currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + currentFormId);
      if (!!currIframe) {
        KAMPYLE_DATA.initOnsiteDefaultState(currentFormId);
        if (currIframe && currIframe.remove) {
          currIframe.remove();
        }

        KAMPYLE_UTILS.setElementStyle(kampyleFormContainer, {
          display: 'none',
          visibility: 'hidden',
        }, true);
      }
      hideVisibility();
      restoreHostingDOM();
    }

    //Close popup
    if (KAMPYLE_DATA.isPopupDisplayType(currentFormId)){
      if (data.sourceWindow && data.sourceWindow.close) {
        data.sourceWindow.close();
      }
    }
  }

  function formatTriangularStyle(formData) {
    var buttonData = formData.buttonData || {};
    var isDynamicButtonSizeEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_DYNAMIC_FEEDBACK_BUTTON_SIZE);
    var btnSize = 81;
    var fontSize = 14;
    var lineHeightTop = 53, lineHeightBottom = 108;
    var buttonStyles = {}, height, buttonPadding, txtWidth;
    var isZoomSupported = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion');

    if (isDynamicButtonSizeEnabled) {
      var buttonTextSize = KAMPYLE_VIEW.getTriangleTextSizeCalculation(formData);
      height = buttonTextSize.height;
      txtWidth = buttonTextSize.width;
      buttonStyles = getDynamicButtonStyles(buttonData.position);
      btnSize = height * 2;
      lineHeightTop = lineHeightBottom = '1.5';
      buttonPadding = buttonTextSize.padding;
    }
    if (isZoomSupported) {
      var z = KAMPYLE_UTILS.getZoomedIn();
      if (z.isZoomedIn) {
        btnSize = String(btnSize * (z.constraint / z.zoom));
        fontSize = String(fontSize * (z.constraint / z.zoom));

        if (isDynamicButtonSizeEnabled) {
          height = String(height * (z.constraint/z.zoom));
          buttonPadding = String(buttonPadding * (z.constraint/z.zoom));
          txtWidth = String(txtWidth * (z.constraint/z.zoom));
        } else {
          lineHeightTop = String(lineHeightTop * (z.constraint / z.zoom));
          lineHeightBottom = String(lineHeightBottom * (z.constraint / z.zoom));
        }
      }
    }
    btnSize = btnSize + 'px';
    fontSize = fontSize + 'px';
    if (!isDynamicButtonSizeEnabled) {
      lineHeightTop = lineHeightTop + 'px';
      lineHeightBottom = lineHeightBottom + 'px';
    }

    var triangularStyle = [
      isDynamicButtonSizeEnabled ? '' : 'button#nebula_div_btn { height: auto }',
      '.kampyle_feedback-button{',
      isDynamicButtonSizeEnabled ? 'width:'+btnSize+';height:'+height+'px;background-color:'+buttonData.backgroundColor+';color:'+buttonData.textColor+';transform:'+buttonStyles.transform+';clip-path:'+buttonStyles.buttonPath+';' : 'background-color:transparent;',
      'font-family:"Open Sans",sans-serif;cursor:pointer;position:fixed;z-index:99999990',
      '}',
      '.kampyle_feedback-button .kampyle_triangle{position:absolute;width:0;height:0;z-index:-1}',
      '.kampyle_feedback-button .kampyle_button-text{',
      isDynamicButtonSizeEnabled ? 'height: auto;width:'+txtWidth+'px;margin: 0 auto;'+buttonStyles.paddingDirection+':'+buttonPadding+'px;' : 'height:'+btnSize+';width:'+btnSize+';',
      'text-align:center;z-index:1000;color:' + buttonData.textColor + ';font-size:' + fontSize + ';font-weight:normal;',
      '}',
      '.kampyle_feedback-button .kampyle_button-text.kampyle_bottom{',
      'line-height:' + lineHeightBottom + ';',
      '}',
      '.kampyle_feedback-button .kampyle_button-text.kampyle_top {',
      'line-height:' + lineHeightTop + ';',
      '}',
      '.kampyle_feedback-button.kampyle_top-right{',
      'top:0;right:0;',
      '}',
      '.kampyle_feedback-button.kampyle_top-left .kampyle_triangle, .kampyle_feedback-button.kampyle_top-right .kampyle_triangle {',
      'top:0;border-top:' + btnSize + ' solid;',
      '}',
      '.kampyle_feedback-button.kampyle_bottom-left .kampyle_triangle, .kampyle_feedback-button.kampyle_bottom-right .kampyle_triangle {',
      'border-bottom:' + btnSize + ' solid;',
      '}',
      '.kampyle_feedback-button.kampyle_bottom-right .kampyle_triangle, .kampyle_feedback-button.kampyle_top-right .kampyle_triangle {',
      'right:0;border-left:' + btnSize + ' solid transparent;',
      '}',
      '.kampyle_feedback-button.kampyle_bottom-left .kampyle_triangle, .kampyle_feedback-button.kampyle_top-left .kampyle_triangle {',
      'left:0;border-right:' + btnSize + ' solid transparent;',
      '}',
      '#nebula_div_btn .kampyle_triangle {',
      'border-bottom-color: ' + buttonData.backgroundColor + ';',
      'border-top-color: ' + buttonData.backgroundColor + ';',
      '}',
      '.kampyle_feedback-button.kampyle_top-right .kampyle_button-text, .kampyle_feedback-button.kampyle_bottom-left .kampyle_button-text {',
        isDynamicButtonSizeEnabled ? '' : '-ms-transform:rotate(45deg);-webkit-transform:rotate(45deg);transform:rotate(45deg);',
      '}',
      '.kampyle_feedback-button.kampyle_top-left .kampyle_button-text, .kampyle_feedback-button.kampyle_bottom-right .kampyle_button-text {',
        isDynamicButtonSizeEnabled ? '' : '-ms-transform:rotate(-45deg);-webkit-transform:rotate(-45deg);transform:rotate(-45deg);',
      '}',
      '.kampyle_feedback-button.kampyle_top-left {',
      'top:0;left:0;',
      '}',
      '.kampyle_feedback-button.kampyle_bottom-right {',
      'bottom:0;right:0;',
      '}',
      '.kampyle_feedback-button.kampyle_bottom-left {',
      'bottom:0;left:0;',
      '}',
      '.kampyle_feedback-button.kampyle_bottom-left, .kampyle_feedback-button.kampyle_bottom-right, .kampyle_feedback-button.kampyle_top-left, .kampyle_feedback-button.kampyle_top-right {',
      'padding: 0;',
      '}',
      isDynamicButtonSizeEnabled ?
          '.kampyle_shape_left { height:100%;width:50%;clip-path:'+buttonStyles.textPath.left+';float:left;shape-outside:'+buttonStyles.textPath.left+'; }' : '',
      isDynamicButtonSizeEnabled ?
          '.kampyle_shape_right { height:100%;width:50%;clip-path:'+buttonStyles.textPath.right+';float:right;shape-outside:'+buttonStyles.textPath.right+'; }' : ''
    ].join(' ');

  return triangularStyle;
}

function getVerticalButtonSize(buttonText) {
  var buttonSize = KAMPYLE_VIEW.getVerticalButtonTextWidth(buttonText);
  var textWidth = buttonSize.width;
  var textHeightPaddingRatio = 0.77;
  var verticalPaddingWidth = 40;
  var minWidth = 125;
  var minHeight = 35;
  return {
    width: Math.max(textWidth + verticalPaddingWidth, minWidth),
    height: Math.max(buttonSize.height + (buttonSize.height * textHeightPaddingRatio), minHeight)
  };
}

  function formatVerticalStyle(formData) {
    var buttonData = formData.buttonData || {};
    var textScaling = '';
    if (MDIGITAL_LOCALIZATION.isFormLanguageRtl(formData)){
      textScaling = 'transform: scale(-1);-ms-transform: scale(-1);-webkit-transform: scale(-1)';
    }
    var fontSize = 14;
    var borderRadius = 3;
    var buttonText = KAMPYLE_VIEW.getButtonText(formData);
    var buttonSize = getVerticalButtonSize(buttonText);
    var width = buttonSize.width;
    var height = buttonSize.height;
    var side = (-width + height)/2;

    if (KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion')) {
      var z = KAMPYLE_UTILS.getZoomedIn();
      if (z.isZoomedIn) {
        width = width * (z.constraint/z.zoom);
        height =  height * (z.constraint/z.zoom);
        fontSize = fontSize * (z.constraint/z.zoom);
        side = side * (z.constraint/z.zoom);
        borderRadius = borderRadius * (z.constraint/z.zoom);
      }
    }
    var borderRadiusLeftStyle = borderRadius+'px ' +borderRadius+'px ' + '0 0';
    var borderRadiusRightStyle =  '0 0 '+borderRadius+'px ' +borderRadius+'px ';
    var VpHeight = window.innerHeight;
    var buttonPosition = VpHeight * 0.55 - width;
    var lineHeight = 'normal';
    var verticalStyle = [
      'button#nebula_div_btn { height: auto }',
      '.kampyle_vertical_button {',
      'background-color:transparent;font-family:"Open Sans",sans-serif;cursor:pointer;position:fixed;bottom:' + buttonPosition + 'px;z-index:99999990;height:'+height+'px;min-height:'+height+'px;max-height:'+height+'px;width:'+width+'px;max-width:'+width+'px;min-width:'+width+'px;-ms-transform:rotate(90deg);-webkit-transform:rotate(90deg);transform:rotate(90deg)',
      '}',
      '.kampyle_vertical_button .kampyle_button {',
      'height:'+height+'px;min-height:'+height+'px;;max-height:'+height+'px;width:'+width+'px;min-width:'+width+'px;max-width:'+width+'px; background:'+buttonData.backgroundColor+';color:'+buttonData.textColor+';position:absolute;top:0;left:0;z-index:-1;',
      '}',
      '.kampyle_vertical_button .kampyle_button-text {',
      'color:'+buttonData.textColor+';font-size:'+fontSize+'px;line-height:'+lineHeight+';text-align:center;font-weight:normal;'+textScaling,
      '}',
      '.kampyle_vertical_button.kampyle_left .kampyle_button {',
      '-webkit-border-radius:'+borderRadiusLeftStyle+';-moz-border-radius:'+borderRadiusLeftStyle+';-ms-border-radius:'+borderRadiusLeftStyle+';border-radius:'+borderRadiusLeftStyle+';',
      '}',
      '.kampyle_vertical_button.kampyle_right {',
      'right:'+side+'px;',
      '}',
      '.kampyle_vertical_button.kampyle_left {',
      'left:'+side+'px;',
      '}',
      '.kampyle_vertical_button.kampyle_right .kampyle_button {',
      '-webkit-border-radius:'+borderRadiusRightStyle+';-moz-border-radius:'+borderRadiusRightStyle+';-ms-border-radius:'+borderRadiusRightStyle+';border-radius:'+borderRadiusRightStyle+';',
      '}',
      '.kampyle_vertical_button.kampyle_right, .kampyle_vertical_button.kampyle_left  {',
      'padding: 0;',
      '}',
    ].join(' ');

    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ADDITIONAL_BUTTON_STYLES)){
      verticalStyle += [
        '.kampyle_vertical_button:hover .kampyle_button-text {',
          'color:'+buttonData.textHoverColor+';',
        '}',
        '.kampyle_vertical_button:hover .kampyle_button {',
          'background-color:'+buttonData.backgroundHoverColor+';',
        '}',
      ].join(' ');
    }

    return verticalStyle;
  }

function getTriangleTextSizeCalculation(formData) {
  var buttonText = KAMPYLE_VIEW.getButtonText(formData);
  // When using shape-outside, the text is pushed to the top.
  // Regardless of the position, the calculation must be based on top triangular.
  // In case of bottom triangular we need to reverse the text to simulate top triangular.
  var shouldReverseText = formData.buttonData.position.includes('bottom');
  if (shouldReverseText) {
    buttonText = buttonText.split('').reverse().join('');
  }
  var buttonStyles = getDynamicButtonStyles('topRight');
  // button container
  var buttonEl = document.createElement('div');
  KAMPYLE_UTILS.addAttributesOnElement(buttonEl, {
    id: 'nebula_div_btn',
    class: 'kampyle_feedback-button',
  });
  KAMPYLE_UTILS.setElementStyle(buttonEl, {
    visibility: 'hidden',
    position: 'fixed',
    border: 'none',
    width: KAMPYLE_CONSTANT.BUTTON.MAX_WIDTH + 'px',
    height: KAMPYLE_CONSTANT.BUTTON.MAX_WIDTH / 2 + 'px',
  });
  // button text container (takes shape's full width, measure text height)
  var buttonTxt = document.createElement('div');
  KAMPYLE_UTILS.addAttributesOnElement(buttonTxt, {
    class: 'kampyle_button-text',
  });
  KAMPYLE_UTILS.setElementStyle(buttonTxt, {
    fontFamily: '"Open Sans",sans-serif',
    width: '100%',
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '1.5',
  });
  // text span (doesn't take shape's full width, measure text width)
  var buttonTxtSpan = document.createElement('span');
  buttonTxtSpan.textContent = buttonText;
  buttonTxt.appendChild(buttonTxtSpan);
  // shapeLeft
  var shapeLeft = document.createElement('div');
  KAMPYLE_UTILS.setElementStyle(shapeLeft, {
    height: '100%',
    width: '50%',
    float: 'left',
    clipPath: buttonStyles.textPath.left,
    shapeOutside: buttonStyles.textPath.left,
  });
  // shapeRight
  var shapeRight = document.createElement('div');
  KAMPYLE_UTILS.setElementStyle(shapeRight, {
    height: '100%',
    width: '50%',
    float: 'right',
    clipPath: buttonStyles.textPath.right,
    shapeOutside: buttonStyles.textPath.right,
  });
  // Must keep the order of elements as they are!
  buttonEl.appendChild(shapeLeft);
  buttonEl.appendChild(shapeRight);
  buttonEl.appendChild(buttonTxt);
  document.body.appendChild(buttonEl);
  var size = {
    width: buttonTxtSpan.offsetWidth + 1, // +1 to avoid rounding issues
    height: buttonTxt.offsetHeight + 1, // +1 to avoid rounding issues
  }
  // Remove shapes to measure text height without shapes gap (when first text is narrower than second text e.g. "Go Clickhereandnowse")
  buttonEl.removeChild(shapeLeft);
  buttonEl.removeChild(shapeRight);
  buttonTxt.style.width = size.width + 'px';
  var textHeightWithoutShapesGap = buttonTxt.offsetHeight;
  size.height = Math.max(size.height, KAMPYLE_CONSTANT.BUTTON.MIN_HEIGHT);

  size.padding = size.height - textHeightWithoutShapesGap;
  document.body.removeChild(buttonEl);

  return size;
}

function getTriangleButtonStyle(formData) {
  var buttonText = KAMPYLE_VIEW.getButtonText(formData);
  var classDirection = getClassDirectonByPosition(formData.buttonData.position);
  var kampyleTriangle = '<div class="kampyle_triangle"></div>', kampyleShape = '';
  var backgroundStyle = "background: none;";
  if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_DYNAMIC_FEEDBACK_BUTTON_SIZE)) {
    kampyleShape = '<div class="kampyle_shape_left"></div><div class="kampyle_shape_right"></div>';
    backgroundStyle = '';
    kampyleTriangle = '';
  }
  return '<button id="nebula_div_btn" style="border: none; ' + backgroundStyle + '" alt="' + buttonText + '" tabindex="0" class="kampyle_feedback-button ' + classDirection.leftright + ' ' + getWCAGClass() + '">' + kampyleTriangle + kampyleShape + '<div data-aut="feedback" class="kampyle_button-text ' + classDirection.topbottom + '">' + buttonText + '</div></button>';
}

  function getVerticalButtonStyle(formData) {
    var direction = 'kampyle_left';
    var buttonText = KAMPYLE_VIEW.getButtonText(formData);
    switch (formData.buttonData.position) {
      case 'left':
        direction = 'kampyle_left';
        break;
      case 'right':
        direction = 'kampyle_right';
        break;
    }
    return '<button id="nebula_div_btn" style="position: fixed !important; border: none" alt="' + buttonText + '" tabindex="0" class="kampyle_vertical_button ' + direction + ' ' + getWCAGClass() + '"><div class="kampyle_button"></div><div data-aut="feedback" class="kampyle_button-text">' + buttonText + '</div></button>';
  }

  function displayGenericFormBtn(formData) {
    var btnBuilders = ({
      vertical: { html: getVerticalButtonStyle, style: formatVerticalStyle },
      triangular: { html: getTriangleButtonStyle, style: formatTriangularStyle }
    })[formData.buttonData.type];
    if (!btnBuilders) {
      KAMPYLE_UTILS.showWarning('Invalid button type ' + formData.buttonData.type);
      return '';
    }
    KAMPYLE_UTILS.addStyle(btnBuilders.style(formData));
    return btnBuilders.html(formData);
  }

  function displayCustomBtn(formData) {
    var divStyle = 'z-index: 99999990;position: fixed;cursor: pointer;line-height:1px; padding:0;';
    var buttonText = KAMPYLE_VIEW.getButtonText(formData);
    var imageBtnStyles = [
      '.nebula_image_button {',
      'width: auto;',
      'background: transparent;',
      '}',
    ].join(' ');
    KAMPYLE_UTILS.addStyle(imageBtnStyles);

    switch (formData.buttonData.position) {
      case 'bottomLeft':
      divStyle += 'bottom:0;left:0;';
      break;
      case 'bottomRight':
      divStyle += 'bottom:0;right:0;';
      break;
      case 'topLeft':
      divStyle += 'top:0;left:0;';
      break;
      case 'topRight':
      divStyle += 'top:0;right:0;';
      break;
      case 'left':
      divStyle += 'left:0;top:50%;';
      break;
      case 'right':
      divStyle += 'right:0;top:50%;';
      break;
      default:
      break;
    }
    return '<button id="nebula_div_btn" class="nebula_image_button ' + getWCAGClass() + '" style="' + divStyle + ';border: none" tabindex="0"><img alt="' + buttonText + '" src="' + formData.buttonData.buttonUrl + '" /></button>';
  }

  function showIframeContainers(formId){
    setMetaViewport('add');
    var kampyleFormContainer = document.getElementById('kampyleFormContainer');
    if (kampyleFormContainer) {
      var currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + formId);
      if (!!currIframe) {
        KAMPYLE_UTILS.setElementStyle(currIframe, {
          display: 'block',
        }, true);
      }
      KAMPYLE_UTILS.setElementStyle(kampyleFormContainer, {
        display: 'block',
        visibility: 'visible',
      }, true);
    }
  }

  function onErrModalClose(formId){
      var NO_JSON_MODAL_ID = "mdigital-no-json-modal_"+formId;
      hideForm({formId:formId});
      var noJsonElement = document.getElementById(NO_JSON_MODAL_ID)
      if(noJsonElement) {
        noJsonElement.style.display = "none";
      }
      KAMPYLE_DATA.setFormState(formId, {
        shown: false
      });
      KAMPYLE_VIEW.resetFormState(formId);
      showButton("",{formId:KAMPYLE_DATA.getMemoryData('buttonFormId')});
      KAMPYLE_UTILS.triggerCustomEvent(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_NO_JSON_MODAL_CLOSED, { formId: formId});
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_NO_JSON_MODAL_CLOSED, { formId: formId});
  }

  function resetFormState(formId) {
    var isInvite = KAMPYLE_DATA.getFormTriggerType(formId) === KAMPYLE_CONSTANT.FORM_TYPES.INVITATION;
    var formJsonMemoryKey = KAMPYLE_DATA.getMemoryJsonKey(formId,isInvite);
    var progressFetchingKey = KAMPYLE_DATA.getMemoryJsonKey(formId,isInvite,KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FETCHING_DATA_IN_PROGRESS);
    KAMPYLE_DATA.setMemoryData(formJsonMemoryKey,null);
    KAMPYLE_DATA.setMemoryData(progressFetchingKey,null);
    KAMPYLE_DATA.setFormState(formId, {loaded:null, loading: null});
    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.IS_BUTTON_CONTAINER_CREATED, false)
    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_RESET_FORM_STATE,{formId:formId});
  }

  function getErrorFetchedModal(formId){
    var errorModalLang = "en";
    var errorMessageTitle = KAMPYLE_CONSTANT.TEXTS.DEFAULT_JSON_ERROR_MESSAGES.title;
    var errorMessageBody = KAMPYLE_CONSTANT.TEXTS.DEFAULT_JSON_ERROR_MESSAGES.body;
    var errorMessageClose = KAMPYLE_CONSTANT.TEXTS.DEFAULT_JSON_ERROR_MESSAGES.close;

    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":true,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isPropertyMessageEnabled){
    errorMessageTitle = MDIGITAL_PROPERTY_MESSAGES.getMessageByTypeAndKey(KAMPYLE_CONSTANT.PROPERTY_MESSAGES.NO_JSON_MESSAGE.TYPE, KAMPYLE_CONSTANT.PROPERTY_MESSAGES.NO_JSON_MESSAGE.KEYS.TITLE);
    errorMessageBody = MDIGITAL_PROPERTY_MESSAGES.getMessageByTypeAndKey(KAMPYLE_CONSTANT.PROPERTY_MESSAGES.NO_JSON_MESSAGE.TYPE, KAMPYLE_CONSTANT.PROPERTY_MESSAGES.NO_JSON_MESSAGE.KEYS.BODY);
    errorMessageClose = MDIGITAL_PROPERTY_MESSAGES.getMessageByTypeAndKey(KAMPYLE_CONSTANT.PROPERTY_MESSAGES.NO_JSON_MESSAGE.TYPE, KAMPYLE_CONSTANT.PROPERTY_MESSAGES.NO_JSON_MESSAGE.KEYS.CLOSE);
    errorModalLang =  MDIGITAL_PROPERTY_MESSAGES.getPropertyMessageLanguageCode();
    }

    var NO_JSON_MODAL_ID = "mdigital-no-json-modal_"+formId;
    return MDIGITAL_ELEMENT_BUILDER.getErrorModal(NO_JSON_MODAL_ID, errorModalLang, errorMessageTitle, errorMessageBody, errorMessageClose);
  }

  function handleButtonClicked(eventName,data){
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var displayType = KAMPYLE_DATA.getDisplayType(formData);
    displayType = displayType.toLowerCase();
    if (displayType === 'lightbox') {
      var kampyleFormContainer = document.getElementById('kampyleFormContainer');
      if (!kampyleFormContainer || KAMPYLE_FUNC.hasApplicationLoadingFailed(data.formId,false) || KAMPYLE_FUNC.isAnyOtherFormAlreadyShown(data.formId,true)) {
        return false;
      }
      KAMPYLE_UTILS.setElementStyle(kampyleFormContainer, {
        display: 'block',
        visibility: 'visible',
      }, true);
    }
  }

  function getClassDirectonByPosition(position){
    var classDirection = { topbottom: 'kampyle_bottom', leftright: 'kampyle_bottom-left' };
    switch (position) {
      case 'bottomLeft':
      classDirection.leftright = 'kampyle_bottom-left';
      classDirection.topbottom = 'kampyle_bottom';
      break;
      case 'bottomRight':
      classDirection.leftright = 'kampyle_bottom-right';
      classDirection.topbottom = 'kampyle_bottom';
      break;
      case 'topLeft':
      classDirection.leftright = 'kampyle_top-left';
      classDirection.topbottom = 'kampyle_top';
      break;
      case 'topRight':
      classDirection.leftright = 'kampyle_top-right';
      classDirection.topbottom = 'kampyle_top';
      break;
      default:
      break;
    }
    return classDirection;
  }

  function getStyleDirectionByPosition(position, btnSize){
    var styleDirection = {};
    switch (position) {
      case 'bottomLeft':
        styleDirection = {
          'border-bottom-width': btnSize,
          'border-right-width': btnSize,
        }
        break;
      case 'bottomRight':
        styleDirection = {
          'border-bottom-width': btnSize,
          'border-left-width': btnSize,
        }
        break;
      case 'topLeft':
        styleDirection = {
          'border-top-width': btnSize,
          'border-right-width': btnSize,
        }
        break;
      case 'topRight':
        styleDirection = {
          'border-top-width': btnSize,
          'border-left-width': btnSize,
        }
        break;
      default:
        break;
    }
    return styleDirection;
  }

  function shouldShowErrMsgOnForm(formId){
    var formTriggerType = KAMPYLE_DATA.getFormTriggerType(formId);
    return MDIGITAL_FORM_STATE.shouldFormBeShown(formId) && (formTriggerType === KAMPYLE_CONSTANT.FORM_TYPES.BUTTON || formTriggerType === KAMPYLE_CONSTANT.FORM_TYPES.CODE);
  }

  function handleCloseButtonInErroModalKeydown(e, formId){
    if(e.keyCode === KAMPYLE_CONSTANT.KEY_CODES.SPACE || e.keyCode === KAMPYLE_CONSTANT.KEY_CODES.ENTER){
      KAMPYLE_VIEW.onErrModalClose(formId);
    }
    else if(e.keyCode === KAMPYLE_CONSTANT.KEY_CODES.TAB){
      e.preventDefault();
      e.stopPropagation();
    }
  }
  function onErrorModalKeyPressed(e, formId) {
    e.preventDefault();

    if (e.keyCode === KAMPYLE_CONSTANT.KEY_CODES.ESC) {
      KAMPYLE_VIEW.onErrModalClose(formId);
      return;
    }

    var closeButtonEl = document.querySelector("#mdigital-no-json-modal_" + formId + " #close-no-json-modal");
    if (!closeButtonEl) return;
    if(e.keyCode === KAMPYLE_CONSTANT.KEY_CODES.TAB && !e.shiftKey){
        closeButtonEl.setAttribute('aria-hidden', false);
        closeButtonEl.focus();
    }
  }

  function showFormCouldNotFechtedErrorMsg(eventName, data){
    if(KAMPYLE_FUNC.isAnyOtherFormAlreadyShown(data.formId) || !KAMPYLE_VIEW.shouldShowErrMsgOnForm(data.formId)){
      return;
    }
    var NO_JSON_MODAL_ID = "mdigital-no-json-modal_"+data.formId;
    var kampyleFormModal = document.getElementById('kampyleFormModal');
    hideSpinner();
    showIframeContainers(data.formId);

    if(document.getElementById(NO_JSON_MODAL_ID)){
      document.getElementById(NO_JSON_MODAL_ID).style.display = "block";
    } else {
      if (!kampyleFormModal) {
        createFormContainer();
        kampyleFormModal = document.getElementById('kampyleFormModal');
        showIframeContainers(data.formId);
      }
      var fetchedDataErrrModal = getErrorFetchedModal(data.formId);
      kampyleFormModal.innerHTML = "";
      if(kampyleFormModal && kampyleFormModal.appendChild ) {
        kampyleFormModal.appendChild(fetchedDataErrrModal);
      }
      var closeBtnElem = document.querySelector("#" + NO_JSON_MODAL_ID + " #close-no-json-modal");
      closeBtnElem.onclick = onErrModalClose.bind(null, data.formId);

      fetchedDataErrrModal.addEventListener("keydown", function (e) {
        onErrorModalKeyPressed(e, data.formId)
      });
      closeBtnElem.addEventListener("keydown", function (e) {
        handleCloseButtonInErroModalKeydown(e, data.formId);
      });
    }

    KAMPYLE_DATA.setFormState(data.formId, {
      loaded: null,
      shown: true,
      shouldBeShown: false
    });
    hideButton("",{formId:KAMPYLE_DATA.getMemoryData('buttonFormId')});
    KAMPYLE_UTILS.triggerCustomEvent(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_NO_JSON_MODAL_SHOWN, {formId: data.formId});

    var failureCause = KAMPYLE_COMMON.getFormFailureCause(data.formId);
    var payload = {
      failureCause: failureCause
    };
    if (failureCause === KAMPYLE_CONSTANT.FORM_LOADING_FAILURE_CAUSE.JSON_FAILED) {
      payload.jsonPath = KAMPYLE_DATA.getDataJsonUrl(data.formId, false);
      // passing false for 'isInviteJson' because there's no scenario where inviteJson will fail
      // and noJson modal will be shown. so we only want the formJsonUrl.
    }
    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_NO_JSON_MODAL_SHOWN, {additionalInfo: payload, formId: data.formId});
  }

  function getButtonByType(buttonType, formData){
    var buttonType = buttonType.toLowerCase();
    if(typeof MDIGITAL_ELEMENT_BUILDER[BUTTON_FUNCTION_ENUM[buttonType]] === 'function'){
      return MDIGITAL_ELEMENT_BUILDER[BUTTON_FUNCTION_ENUM[buttonType]](formData);
    }
    else{

      MDIGITAL_LOGGER.error('Invalid button type - ' + buttonType);

      return null;
    }
  }

  function showFeedbackButtonVisually() {
    var button = document.getElementById(KAMPYLE_CONSTANT.VIEW.FEEDBACK_BUTTON_ID);
    if (button == null) return;

    KAMPYLE_UTILS.setElementStyle(button, getVisualHideOrShowStyles(false), false);
    KAMPYLE_UTILS.removeAttribute(button, "tabindex");
    KAMPYLE_UTILS.removeAttribute(button, "aria-hidden");
  }

  function hideFeedbackButtonVisually() {
    var button = document.getElementById(KAMPYLE_CONSTANT.VIEW.FEEDBACK_BUTTON_ID);
    if (button == null) return;

    KAMPYLE_UTILS.setElementStyle(button, getVisualHideOrShowStyles(true), false);
    KAMPYLE_UTILS.addAttributesOnElement(button, {
      tabindex: -1,
      'aria-hidden':true
    })
  }

  function showButton(eventName, data) {
    if (document.getElementById(KAMPYLE_CONSTANT.VIEW.FEEDBACK_BUTTON_CONTAINER_ID) != null
      && document.getElementById(KAMPYLE_CONSTANT.VIEW.FEEDBACK_BUTTON_ID) != null) {
        KAMPYLE_VIEW.showFeedbackButtonVisually();
        triggerDisplayEvent(eventName, data);
    }
    else {
      KAMPYLE_VIEW.createButton(eventName, data);
    }
  }

  function triggerDisplayEvent(evetName, data){
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId) || {};

    KAMPYLE_EVENT_DISPATCHER.trigger('neb_button_displayed', {
      formId: data.formId,
      position: KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.position') || '',
      formClosed:KAMPYLE_UTILS.getNestedPropertyValue(data,'formClosed') || false
    });
  }

  function getVisualHideOrShowStyles(isHide) {
    var cachedButtonPosition = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FEEDBACK_BUTTON_POSITION_STYLE) || {};
    var transformValue = '';
    var distance = isHide ? '9999px' : 0;
    switch (cachedButtonPosition) {
      case 'left':
        transformValue = 'rotate(90deg) translateY(' + distance + ')';
        break;
      case 'right':
        transformValue = 'rotate(90deg) translateY(-' + distance + ')';
        break;
      case 'bottomRight':
      case 'topRight':
        if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_DYNAMIC_FEEDBACK_BUTTON_SIZE)) {
          transformValue = distance ? 'translateX(' + distance + ')' : getDynamicButtonStyles(cachedButtonPosition).transform;
          break;
        }
        transformValue = 'translateX(' + distance + ')';
        break;
      case 'customRight':
        transformValue = 'translateX(' + distance + ')';
        break;
      case 'bottomLeft':
      case 'topLeft':
        if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_DYNAMIC_FEEDBACK_BUTTON_SIZE)) {
          transformValue = distance ? 'translateX(-' + distance + ')' : getDynamicButtonStyles(cachedButtonPosition).transform;
          break;
        }
        transformValue = 'translateX(-' + distance + ')';
        break;
      case 'customLeft':
        transformValue = 'translateX(-' + distance + ')';
        break;
    }

    return {transform: transformValue};
  }

  function pickElementStyleProperties(button, properties) {
    var buttonStyle = button && button.style;
    return (buttonStyle != null && properties != null && properties.length) ? properties.reduce(function (acc, key) {
      var value = buttonStyle[key];
      if (value != null) {
        acc[key] = value;
      }
      return acc;
    }, {}) : {}
  }

  function handleLoadCustomBtnEvent(imgElement, btnStaticData) {
    if (Number(imgElement.naturalWidth) > 0 && Number(imgElement.naturalHeight) > 0) {
      var buttonEl = document.getElementById('nebula_div_btn');
      var imgData = {
        el: imgElement,
        width: imgElement.naturalWidth,
        height: imgElement.naturalHeight
      }
      styleCustomBtn(buttonEl, imgData, btnStaticData);
      if (boundHandleLoadCustomBtnEvent) {
         KAMPYLE_UTILS.removeEventHandler(imgElement, 'load', boundHandleLoadCustomBtnEvent);
      }
    }
  }

  // This function add the kampyle button to page
  function createButton(eventName, data) {
    var btnHtml = '';
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId) || {};
    var buttonType = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.type') || '';
    var spanContainer;
    var btnStaticData = {
      buttonVerticalOffset: KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.verticalOffset') || '',
      buttonType: buttonType,
      buttonPosition: getButtonDirection(formData),
    }

    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CSP_RULES)) {
      var buttonElement = getButtonByType(buttonType, formData);
      if(buttonElement){
        spanContainer = document.getElementById('kampyleButtonContainer');
        if (spanContainer === null) {
          spanContainer = document.createElement('span');
          spanContainer.id = 'kampyleButtonContainer';
          spanContainer.appendChild(buttonElement);
          document.body.appendChild(spanContainer);
        }
        else {
          spanContainer.innerHTML = "";
          spanContainer.appendChild(buttonElement);
        }
      }
    } else {
      switch (buttonType.toLowerCase()) {
        case 'vertical':
        case 'triangular':
          btnHtml = displayGenericFormBtn(formData);
          break;
        case 'custom':
          btnHtml = displayCustomBtn(formData);
          break;
        default:
          KAMPYLE_UTILS.showWarning('Invalid button type - ' + buttonType);
          return false;
      }
      spanContainer = document.getElementById('kampyleButtonContainer');
      if (spanContainer === null) {
        spanContainer = document.createElement('span');
        spanContainer.innerHTML = btnHtml;
        spanContainer.id = 'kampyleButtonContainer';
        document.body.appendChild(spanContainer);
      }
      else {
        spanContainer.innerHTML = btnHtml;
      }
    }

    if (buttonType.toLowerCase() === 'custom') {
      var imgElement = document.querySelector('#nebula_div_btn > img');
      boundHandleLoadCustomBtnEvent = handleLoadCustomBtnEvent.bind(this, imgElement, btnStaticData);
      KAMPYLE_UTILS.setEventHandler(imgElement, 'load', boundHandleLoadCustomBtnEvent);
      if (imgElement.complete && imgElement.naturalWidth > 0) {
        handleLoadCustomBtnEvent(imgElement, btnStaticData);
      }
    }

    var positionStyle = btnStaticData.buttonPosition;
    if (buttonType.toLowerCase() === 'custom') {
      positionStyle = btnStaticData.buttonPosition.toLowerCase().indexOf('right') > -1 ? 'customRight' : 'customLeft';
    }
    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FEEDBACK_BUTTON_POSITION_STYLE, positionStyle); // defaults to 'right'

    KAMPYLE_EVENT_DISPATCHER.trigger('neb_button_displayed', {
      formId: data.formId,
      position: KAMPYLE_UTILS.getNestedPropertyValue(formData, 'buttonData.position') || '',
      formClosed:KAMPYLE_UTILS.getNestedPropertyValue(data,'formClosed') || false
    });
    spanContainer.onclick = function (event) {
      if(!KAMPYLE_FUNC.isAnyOtherFormAlreadyShown(data.formId,true)){
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_buttonClicked', { formId: data.formId });
        event.preventDefault();
        event.stopPropagation();
      }
    };

    var isDesktop = KAMPYLE_DATA.getMemoryData('kampyleDevice') === KAMPYLE_CONSTANT.DEVICES.DESKTOP;

    if (isDesktop) {
      // No proximity - only on mouse over
      this.boundHandleLoadFormEvent = handleLoadFormEvent.bind(this,data,spanContainer);
      KAMPYLE_UTILS.setEventHandler(spanContainer, 'mouseover', this.boundHandleLoadFormEvent);

      var buttonProximityFunc = function (event) {
        var formState = KAMPYLE_DATA.getFormState(data.formId);
        var skipOnInviteLoadedAndShown = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_INVITATION_SPINNER_FIX) && KAMPYLE_DATA.getMemoryData('inviteLoadedAndShown');
        if (!formState || formState.loading || formState.loaded || skipOnInviteLoadedAndShown || KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.IS_BUTTON_CONTAINER_CREATED)){
          return false;
        }

        var isNear = KAMPYLE_UTILS.isNear('nebula_div_btn', 100, event);
        if (isNear) {
          // Load form (proximity implementation)
          KAMPYLE_EVENT_DISPATCHER.trigger('neb_load_form_preload_proximity', { formId: data.formId });
          KAMPYLE_EVENT_DISPATCHER.trigger('neb_loadForm', { formId: data.formId });
          KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.IS_BUTTON_CONTAINER_CREATED, true);
        }
      };
      KAMPYLE_UTILS.setEventHandler(window, 'mousemove', buttonProximityFunc);
    }

    spanContainer.onkeyup = function (event) {
      //if keyboard enter pressed
      switch (event.keyCode) {
        case KAMPYLE_CONSTANT.KEY_CODES.TAB:
          if (!MDIGITAL_FORM_STATE.isFormLoaded(data.formId)) {
            KAMPYLE_EVENT_DISPATCHER.trigger('neb_loadForm', { formId: data.formId });
          }
        break;
        default:
        break;
      }

    };


    spanContainer.onkeypress = function (event) {
      //if keyboard enter pressed
      switch (event.keyCode) {
        case KAMPYLE_CONSTANT.KEY_CODES.ENTER:
        if(!KAMPYLE_FUNC.isAnyOtherFormAlreadyShown(data.formId,true)){
          KAMPYLE_EVENT_DISPATCHER.trigger('neb_buttonClicked', { formId: data.formId });
        }
        break;
        default:
        break;
      }
    };
  }

  function handleLoadFormEvent(data,spanContainerEl) {
    var formState = KAMPYLE_DATA.getFormState(data.formId);
    if (!(formState.loaded || KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.IS_BUTTON_CONTAINER_CREATED))) {
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_loadForm', { formId: data.formId });
      KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.IS_BUTTON_CONTAINER_CREATED, true);
    }
    KAMPYLE_UTILS.removeEventHandler(spanContainerEl, 'mouseover', this.boundHandleLoadFormEvent);
  }
  function setIframeOrigin(eventName, data) {
    if (data.origin != undefined) {
      var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + data.formId);
      if (formIframe && formIframe.setAttribute) {
        formIframe.setAttribute('origin', data.origin);
      }
    }
  }

  function styleVerticalBtnToZoom(z, buttonEl, buttonTxt) {
    var rightVertical = document.querySelector('.kampyle_vertical_button.kampyle_right');
    var leftVertical = document.querySelector('.kampyle_vertical_button.kampyle_left');
    var buttonBg = document.querySelector('.kampyle_button');
    var constraint = z.constraint;
    var height = 35;
    var width = 125;
    var fontSize = 14;

    var buttonSize = getVerticalButtonSize(buttonTxt.textContent);
    width = buttonSize.width;
    height = buttonSize.height;
    var side = (-width + height)/2;
    width = z.isZoomedIn ? String(width * (constraint/z.zoom)) + 'px' : width + 'px';
    height = z.isZoomedIn ? String(height * (constraint/z.zoom)) + 'px' : height + 'px';
    side = z.isZoomedIn ? String(side * (constraint/z.zoom))+'px' : side + 'px';
    fontSize = z.isZoomedIn ? String(fontSize * (constraint/z.zoom))+'px' : fontSize + 'px';
    KAMPYLE_UTILS.setElementStyle(buttonEl, {
      width: width,
      minWidth: width,
      maxWidth: width,
      height: height,
      minHeight: height,
      maxHeight: height,
    }, false);
    KAMPYLE_UTILS.setElementStyle(rightVertical, {
      right: side,
    }, false);
    KAMPYLE_UTILS.setElementStyle(leftVertical, {
      left: side,
    }, false);
    KAMPYLE_UTILS.setElementStyle(buttonBg, {
      width: width,
      minWidth: width,
      maxWidth: width,
      height: height,
      minHeight: height,
      maxHeight: height,
    }, false);
    KAMPYLE_UTILS.setElementStyle(buttonTxt, {
      lineHeight: 'normal',
      fontSize: fontSize,
    }, false);
  }

function styleTriangularBtnToZoom(z, buttonEl, buttonTxt, formData) {
  var isDynamicButtonSizeEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_DYNAMIC_FEEDBACK_BUTTON_SIZE);
  var width = 81, txtWidth, height;
  var fontSize = 14;
  var constraint = z.constraint;
  var buttonStyles = {}, buttonTxtStyle = {}, lineHeight, buttonPadding;
  var buttonPosition = getButtonDirection(formData);

  if (isDynamicButtonSizeEnabled) {
    var buttonTextSize = KAMPYLE_VIEW.getTriangleTextSizeCalculation(formData);
    buttonStyles = KAMPYLE_VIEW.getDynamicButtonStyles(buttonPosition);
    height = buttonTextSize.height;
    width = buttonTextSize.height * 2;
    buttonPadding = buttonTextSize.padding;
    txtWidth = buttonTextSize.width;
    lineHeight = 1.5;
    if (z.isZoomedIn) {
      var multiplier = constraint/z.zoom;
      txtWidth = txtWidth * multiplier;
      height = height * multiplier;
      buttonPadding = buttonPadding * multiplier;
    }
  } else {
    var lineHeightTop = 53;
    var lineHeightBottom = 108;
    lineHeight = buttonPosition.indexOf('top') === 0 ? lineHeightTop : lineHeightBottom;
    lineHeight = z.isZoomedIn ? String(lineHeight * (constraint/z.zoom)) + 'px' : lineHeight + 'px';
  }
  var btnSize = z.isZoomedIn ? String(width * (constraint/z.zoom)) + 'px' : width + 'px';
  fontSize = z.isZoomedIn ? String(fontSize * (constraint/z.zoom))+'px' : fontSize+'px';

  if (isDynamicButtonSizeEnabled) {
    KAMPYLE_UTILS.setElementStyle(buttonEl, {
      height: height + 'px',
      width: btnSize,
      fontSize: fontSize,
      lineHeight: lineHeight,
    }, false);
    buttonTxtStyle = {
      height: 'auto',
      margin: '0 auto',
      width: txtWidth + 'px',
      fontSize: fontSize,
      lineHeight: lineHeight,
    }
    buttonTxtStyle[buttonStyles.paddingDirection] = buttonPadding + 'px';
    KAMPYLE_UTILS.setElementStyle(buttonTxt, buttonTxtStyle, false);
  } else {
    KAMPYLE_UTILS.setElementStyle(buttonEl, {
      lineHeight: lineHeight,
    }, false);
    KAMPYLE_UTILS.setElementStyle(buttonTxt, {
      height: btnSize,
      width: btnSize,
      fontSize: fontSize,
      lineHeight: lineHeight,
    }, false);
    var triangleBackground = document.querySelector('.kampyle_triangle');
    var responsiveBorderWidth = getStyleDirectionByPosition(buttonPosition, btnSize);
    KAMPYLE_UTILS.setElementStyle(triangleBackground, responsiveBorderWidth, true);
  }
}

function getVerticalButtonTextWidth(textContent) {

  var el = document.createElement("div");
  el.style.position = "absolute";
  el.style.visibility = "hidden";
  el.style.width = 'auto';
  el.style.font = '14px "Open Sans", sans-serif';
  el.style.lineHeight = "1";
  el.innerText = textContent;
  document.body.appendChild(el);
  var width = el.offsetWidth;
  var height = el.offsetHeight;
  document.body.removeChild(el);
  return {
    width: width,
    height: height
  };
}

function getDynamicButtonStyles(buttonPosition) {
  var clipPathRight, clipPathLeft, transform, paddingDirection, buttonPath;
  switch (buttonPosition) {
    case 'topLeft':
      buttonPath = 'polygon(0 100%, 50% 0%, 100% 100%)';
      clipPathRight = 'polygon(0% 0%, 100% 100%, 100% 0%)';
      clipPathLeft = 'polygon(0% 100%, 0% 0%, 100% 0%)';
      transform = 'rotate(-45deg) translate(-18%, -58%)';
      paddingDirection = 'padding-top';
      break;
    case 'topRight':
      buttonPath = 'polygon(0 100%, 50% 0%, 100% 100%)';
      clipPathRight = 'polygon(0% 0%, 100% 100%, 100% 0%)';
      clipPathLeft = 'polygon(0% 100%, 0% 0%, 100% 0%)';
      transform = 'rotate(45deg) translate(18%, -58%)';
      paddingDirection = 'padding-top';
      break;
    case 'bottomLeft':
      buttonPath = 'polygon(0 0%, 50% 100%, 100% 0%)';
      clipPathRight = 'polygon(0% 100%, 100% 0%, 100% 100%)';
      clipPathLeft = 'polygon(0% 100%, 0% 0%, 100% 100%)';
      transform = 'rotate(45deg) translate(-18%, 58%)';
      paddingDirection = 'padding-bottom';
      break;
    case 'bottomRight':
      buttonPath = 'polygon(0 0%, 50% 100%, 100% 0%)';
      clipPathRight = 'polygon(0% 100%, 100% 0%, 100% 100%)';
      clipPathLeft = 'polygon(0% 100%, 0% 0%, 100% 100%)';
      transform = 'rotate(-45deg) translate(18%, 58%)';
      paddingDirection = 'padding-bottom';
      break;
    default:
      buttonPath = 'unset';
      clipPathRight = 'unset';
      clipPathLeft = 'unset';
      transform = 'unset';
      paddingDirection = 'padding-bottom';
      break;
  }
  return {
    textPath: {
      right: clipPathRight,
      left: clipPathLeft,
    },
    buttonPath: buttonPath,
    transform: transform,
    paddingDirection: paddingDirection,
  }
}

  function getBottomPositionCustomBtn(buttonPosition, imgHeight, offset) {
    var vertical = {};
    if (buttonPosition.indexOf('bottom') > -1) {
      vertical = {
        bottom: 0,
        marginBottom: offset + 'px',
        top: 'unset',
      }
    } else if (buttonPosition.indexOf('top') > -1) {
      vertical = {
        top: 0,
        marginTop: offset * -1 + 'px',
        bottom: 'unset'
      }
    } else {
      vertical = {
        bottom: window.innerHeight * 0.5 - imgHeight + 'px',
        marginBottom: offset + 'px',
        top: 'unset'
      }
    }
    return vertical;
  }

  function styleCustomBtn(buttonEl, imgData, btnStaticData) {
    var multiplier = 1 / KAMPYLE_UTILS.getZoomedIn().zoom;
    var imgElement = imgData ? imgData.el : document.querySelector('#nebula_div_btn>img');
    var imgNaturalWidth = imgData ? imgData.width : imgElement.naturalWidth;
    var imgNaturalHeight = imgData ? imgData.height : imgElement.naturalHeight;
    var imgWidth = String(imgNaturalWidth * multiplier);
    var imgHeight = String(imgNaturalHeight * multiplier);
    var offset = btnStaticData.buttonVerticalOffset;
    offset = isNaN(offset) ? 0 : Number(offset) * multiplier;
    var verticalPositioning = getBottomPositionCustomBtn(btnStaticData.buttonPosition, imgHeight, offset);
    KAMPYLE_UTILS.setElementStyle(buttonEl, {
      width: imgWidth + 'px',
      height: imgHeight + 'px',
    }, false);
    KAMPYLE_UTILS.setElementStyle(buttonEl, verticalPositioning, true);
    KAMPYLE_UTILS.setElementStyle(imgElement, {
      width: 'inherit',
      height: 'inherit',
    }, false);
  }

  function resizeButton(btnStaticData, formData) {
    var buttonEl = document.getElementById('nebula_div_btn');
    if (buttonEl === null) { return; }
    var buttonTxtEl = document.querySelector('.kampyle_button-text');
    var browserZoom = KAMPYLE_UTILS.getZoomedIn();
    if (btnStaticData.buttonType === 'vertical') {
      styleVerticalBtnToZoom(browserZoom, buttonEl, buttonTxtEl, btnStaticData.buttonPosition);
    } else if (btnStaticData.buttonType === 'triangular') {
      styleTriangularBtnToZoom(browserZoom, buttonEl, buttonTxtEl, formData);
    }
  }

  function updateIframeStyle(formData) {
    var currentFormId = KAMPYLE_DATA.getMemoryData('currentFormId') || KAMPYLE_DATA.getShownFormId();
    if (document.getElementById('kampyleFormContainer') === null || !currentFormId) { return; }
    formData = formData || KAMPYLE_DATA.getFormData(currentFormId) || {};
    if (KAMPYLE_DATA.isMobileDynamicSizing(formData.formId)) {
      return updateDynamicIframeStyle(formData);
    } else {
      updateStaticIframeStyle(formData);
    }
  }

  function updateStaticIframeStyle(formData) {
    var currentFormId = (formData || {}).formId || KAMPYLE_DATA.getMemoryData('currentFormId') || KAMPYLE_DATA.getShownFormId();
    var formWidth;
    var formHeight;
    if (formData) {
      formWidth = parseInt(formData.formWidth, 10) || 450;
      formHeight = parseInt(formData.formHeight, 10) || 450;
    }

    var hostHeight = document.documentElement.clientHeight;

    var innerContainerStyle = {
      overflowY: 'auto',
      height: '100%',
    };

    KAMPYLE_UTILS.setElementStyle(document.getElementById('innerContainer'), innerContainerStyle);


    //TODO - nowe that the iFrame takes 100% of the page, remove some of the logic
    var iframeStyleObject = {
      border: 0,
      position: 'relative',
      margin: '50px auto 50px',
      height: formHeight + 'px',
      width: formWidth + 'px',
    };
    var kampyleDevice = KAMPYLE_DATA.getMemoryData('kampyleDevice');

    if (kampyleDevice === KAMPYLE_CONSTANT.DEVICES.MOBILE || kampyleDevice === KAMPYLE_CONSTANT.DEVICES.TABLET) {
      formHeight = '100%';
      formWidth = '100%';
      iframeStyleObject = {
        position: 'relative',
        margin: '0',
        height: formHeight,
        width: formWidth,
      };
    }
    else if (KAMPYLE_DATA.isCustomHtmlAndFixedSizeForm(currentFormId)) {
      iframeStyleObject = {
        position: 'absolute',
        top: '50%',
        'margin-top': - formHeight / 2 + 'px',
        left: '50%',
        'margin-left': - formWidth / 2 + 'px',
        height: formHeight + 'px',
        width: formWidth + 'px',
      };

      if (hostHeight < formHeight) {
        iframeStyleObject.position = 'relative';
        iframeStyleObject.top = '0';
        iframeStyleObject['margin-top'] = '50px';
        iframeStyleObject['margin-bottom'] = '50px';
      }
    }
    else {
      iframeStyleObject = {
        position: 'fixed',
        height: '100%',
        width: '100%',
      };
    }

    var modal = document.getElementById('kampyleFormModal');
    if (modal && modal.style && modal.removeAttribute) {
      modal.removeAttribute('style');

      KAMPYLE_UTILS.setElementStyle(modal, iframeStyleObject, true /* force !important */);
    }
  }

  function updateDynamicIframeStyle(formData) {
    var spanContainer = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.WRAPPER_ID);
    if (spanContainer) { spanContainer.setAttribute('aria-hidden', false); }
    var modal = document.getElementById('kampyleFormModal');
    if (modal) {
      KAMPYLE_UTILS.setElementStyle(modal, {
        top: 0,
        margin: 0,
        width: '100%',
      }, true /* force !important */);
    }
  }

  function openPopup(formUrl, formId, formWidth, formHeight, eventName) {
    formUrl = KAMPYLE_COMMON.createFormUrl(formUrl, formId);
    var popupPageName = 'NebulaCX' + formId;
    var popupSettings = 'width=' + formWidth + ', height=' + formHeight + ',scrollbars=yes';
    var popupHandler = window.open(formUrl, popupPageName, popupSettings);
    //If popupHandler is undefined or null - IE & FireFox Blocked the popUp,
    // In Chrome if popupHandler is closed or the typeof popupHandler.closed is undifined - Chrome Blocked the popUp.
    var isPopupBlocked = !popupHandler || popupHandler.closed || typeof popupHandler.closed == 'undefined'
    KAMPYLE_DATA.setMemoryData('popupHandler', popupHandler);

		setTimeout(function() {
			if (isPopupBlocked) {
        if (eventName !== 'neb_skipInvitation') {
					alert("The survey was blocked, please disable popup blocker and refresh the page.");
				}
				KAMPYLE_EVENT_DISPATCHER.trigger('neb_popupBlocked', {
					formId: formId
				});
			}
		}, 25);
  }

  function handlePopupShow(formUrl, formId, formWidth, formHeight, eventName){
    if(KAMPYLE_FUNC.shouldRenderForm({formId:formId})){
      openPopup(formUrl, formId, formWidth, formHeight, eventName);
    }
  }


  // Show form
  function showForm(eventName, data) {
    var isSkipInvitationEvent = eventName === 'neb_skipInvitation';
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    if (KAMPYLE_VIEW.ignoreShowForm(formData) || KAMPYLE_FUNC.hasApplicationLoadingFailed(data.formId,false) || KAMPYLE_FUNC.isAnyOtherFormAlreadyShown(data.formId,true)) {
      return false;
    }
    var formUrl = formData.formHtmlUrl;
    var formWidth = formData.formWidth;
    var formHeight = formData.formHeight;

    var displayType = KAMPYLE_DATA.getDisplayType(formData);
    displayType = displayType.toLowerCase();
    setMetaViewport('add');

    KAMPYLE_DATA.setMemoryData('currentFormId', data.formId);

    if(!KAMPYLE_DATA.isEmbeddedDisplayType(data.formId)){
      KAMPYLE_DATA.setMemoryData('formIsShown', true);
      //Since we are waiting for invitation to be load first and then just show the layout on the screen, user are enable to press on alwayws button
      //In this case we should not allowed users to see the inviation anymore until sdkpageview.
      KAMPYLE_DATA.setMemoryData('isInvitationShouldBeIgnored', true);
    }
    var kampyleDevice = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var shouldOptimizeSkipInvitation = isSkipInvitationEvent && KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SKIP_INVITATION_OPTIMIZATION);

    if (displayType === 'lightbox') {
      if (!shouldOptimizeSkipInvitation) {
        KAMPYLE_VIEW.prepareHostingDOM();
      } else {
        KAMPYLE_DATA.setData('isSkipInvitationOptimized', true);
      }

      // get width and height support ie8
      //Append the form id to the url as url param for custom html files that don't have it
      var kampyleFormContainer = document.getElementById('kampyleFormContainer');
      if (kampyleFormContainer) {
        updateIframeStyle(formData);

        var currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + data.formId);
        if (!!currIframe) {
          KAMPYLE_UTILS.setElementStyle(currIframe, {
            display: 'block',
          }, true);
        }

        KAMPYLE_UTILS.setElementStyle(kampyleFormContainer, {
          display: 'block',
          visibility: shouldOptimizeSkipInvitation ? 'hidden' : 'visible',
        }, true);


      }
      else {
        KAMPYLE_UTILS.showWarning("formContainer wasn't loaded properly");
      }

    }
    else if (displayType === 'popup') {
      handlePopupShow(formUrl, data.formId, formWidth, formHeight, eventName);
    }
    return true;
  }

  function ignoreShowForm(formData) {
    return (
      !formData ||
      KAMPYLE_DATA.getDisplayType(formData) === 'animation'
    )
  }

  // Hide the invite lightbox
  function hideInvite() {
    KAMPYLE_DATA.setMemoryData('inviteLoadedAndShown', false);
    setMetaViewport('remove');
    var inviteContainer = document.getElementById('kampyleInviteContainer');
    var kampyleInvite = document.getElementById('kampyleInvite');

    if (inviteContainer && kampyleInvite) {
      KAMPYLE_UTILS.setElementStyle(inviteContainer, {
        display: 'none',
      }, true /* important */);

      restoreHostingDOM();
    }
  }

  function changeInviteHeight(eventName, data) {
    data = data || {};
    var positions = ['top', 'bottom'];
    var isInviteShown = (KAMPYLE_DATA.getFormState(data.formId) || {}).inviteShown;
    if (!newMobileInvite() || !isInviteShown) {
      return false;
    }
    var pos = KAMPYLE_VIEW.getInvitePosition(data.formId);
    var inviteContainer = document.getElementById('kampyleInviteContainer');
    var inviteIframe = document.getElementById('kampyleInvite');

    //if focusable element is already in focus hide the invite because its mean the keyboard is open and we dont want to show the invite when the keyboard is open
    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      KAMPYLE_UTILS.hideInvite();
      KAMPYLE_UTILS.setEventHandler(document.activeElement, 'blur', (function(elm) { return function onBlurCallback() {
        KAMPYLE_UTILS.removeEventHandler(elm, 'blur', onBlurCallback);
        KAMPYLE_UTILS.showInvite();
      };})(document.activeElement));
    } else {
      KAMPYLE_UTILS.showInvite();
    }

    var style = {
      display: 'block',
      height: data.newHeight + 'px',
      left: '0',
      right: '0',
    };
    style[pos] = 0;
    style[positions[(positions.indexOf(pos) + 1) % 2]] = ''; // clear the other postion
    KAMPYLE_UTILS.setElementStyle(inviteContainer, style, true /* important */);
  }

  //Sets and removes hosing page's meta viewport tags
  function setMetaViewport(optional) {
    optional = optional || '';
    if (KAMPYLE_DATA.getMemoryData('kampyleDevice') === 'desktop') {
      return;
    }
    var isWCAGUserScalable = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATES_WCAG) ? 'width=device-width, initial-scale=1.0' : 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    var kampyleMeta = document.getElementById('kampyleMetaViewport');
    var viewportAmendContentAttributeOnlyProvision = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_VIEWPORT_LOGIC_FIX);

    var savedViewportContent = KAMPYLE_DATA.getMemoryData('hostedViewportContent') || [];

    if (!savedViewportContent.length) {
      var hostedViewportElements = document.getElementsByName('viewport');
      var isHostedViewportElementExists = hostedViewportElements && hostedViewportElements.length > 0;
      if (isHostedViewportElementExists) {
        
        for (var i = hostedViewportElements.length - 1; i >= 0; i--) {
          var viewportContent = hostedViewportElements[i].getAttribute('content');
          if (viewportContent) {
            if (viewportAmendContentAttributeOnlyProvision) {
              savedViewportContent.push({
                el: hostedViewportElements[i],
                content: viewportContent
              });
            } else {
              savedViewportContent.push(hostedViewportElements[i]);
            }
          }
        }

      }
    }

    var shouldSetMetaContentInsteadOfElement = viewportAmendContentAttributeOnlyProvision && !!savedViewportContent.length && !kampyleMeta;

    switch (optional.toLowerCase()) {
      case 'add':
        if (savedViewportContent && savedViewportContent.length) {
          for (var i = savedViewportContent.length - 1; i >= 0; i--) {
            if (shouldSetMetaContentInsteadOfElement) {
              if (savedViewportContent[i].el) {
                savedViewportContent[i].el.setAttribute('content', isWCAGUserScalable);
              }
            } else if (!savedViewportContent[i].el) {
              if (savedViewportContent[i].hasAttribute('id') && savedViewportContent[i].id === 'kampyleMetaViewport') {
                continue;
              } else {
                if (savedViewportContent[i].remove) {
                  savedViewportContent[i].remove();
                }
              }
            }
          }
        }
        if (!shouldSetMetaContentInsteadOfElement) {
          if (!kampyleMeta) {
            var meta = document.createElement('meta');
            meta.content = isWCAGUserScalable;
            meta.name = 'viewport';
            meta.id = 'kampyleMetaViewport';
            document.getElementsByTagName('head')[0].appendChild(meta);
          } else {
            kampyleMeta.content = isWCAGUserScalable;
            kampyleMeta.name = 'viewport';
          }
        }
        break;
      case 'remove':
        if (kampyleMeta) {
          kampyleMeta.content = '';
          kampyleMeta.name = '';

          if (kampyleMeta.remove) {
            kampyleMeta.remove();
          }
        }
        if (savedViewportContent && savedViewportContent.length) {
          for (var i = savedViewportContent.length - 1; i >= 0; i--) {
            if (shouldSetMetaContentInsteadOfElement) {
              if (savedViewportContent[i].el) {
                savedViewportContent[i].el.setAttribute('content', savedViewportContent[i].content);
              }
            } else if (!savedViewportContent[i].el) {
              if (savedViewportContent[i].hasAttribute('id') &&
                savedViewportContent[i].id === 'kampyleMetaViewport') {
                continue;
              } else {
                document.getElementsByTagName('head')[0].appendChild(savedViewportContent[i]);
              }
            }
          }
        }
        break;
    }

    KAMPYLE_DATA.setMemoryData('hostedViewportContent', savedViewportContent);
  }

  function newMobileInvite() {
    return (Number(KAMPYLE_DATA.getMemoryData('inviteVersion')) > 0) && KAMPYLE_DATA.isNewMobileInvitation();
  }

  function getInvitePosition(formId) {
    var formData = (KAMPYLE_DATA.getFormData(formId) || {});
    return (formData.inviteData || {}).invitationPosition || 'top';
  }

  // Show the invite lightbox
  function showInvite(eventName, data) {
    setMetaViewport('add');
    var inviteData = KAMPYLE_DATA.getInviteData(data.formId);
    var inviteTop = '25%';
    var inviteTransform = 'none';

    if (!inviteData || !MDIGITAL_FORM_STATE.isInviteLoaded(data.formId) || !KAMPYLE_FUNC.isJsonDataLoaded(data.formId,true)){
      return false;
    }

    var kampyleDevice = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var inviteMaxWidth = '100vw';
    var inviteMaxHeight = '100vh';
    if (kampyleDevice === KAMPYLE_CONSTANT.DEVICES.MOBILE || kampyleDevice === KAMPYLE_CONSTANT.DEVICES.TABLET) {
      inviteData.inviteHeight = '100%';
      inviteData.inviteWidth = '100%';
      inviteTop = 0;
    } else {
      inviteTop = '50%';
      inviteTransform = 'translateY(-50%)';
    }

    var invitationTimeStamp = KAMPYLE_UTILS.getCurrentTimestamp();
    KAMPYLE_DATA.setMemoryData('invitationTimeStamp', invitationTimeStamp);
    KAMPYLE_DATA.setData('LAST_INVITATION_VIEW', invitationTimeStamp);

    var inviteContainer = document.getElementById('kampyleInviteContainer');
    if (inviteContainer && KAMPYLE_DATA.getMemoryData('formIsShown') === false) {

      KAMPYLE_UTILS.setElementStyle(inviteContainer, {
        display: 'block',
        visibility: KAMPYLE_DATA.isNewMobileInvitation() ? 'hidden' : 'visible',
      }, true /* !important */);

      prepareHostingDOM();

      KAMPYLE_EVENT_DISPATCHER.trigger('neb_invitation_ready', { formId: data.formId });
      //invite modal style
      var inviteModal = document.getElementById('kampyleInviteModal');
      if (inviteModal) {

        KAMPYLE_UTILS.setElementStyle(inviteModal, {
          top: inviteTop,
          width: inviteData.inviteWidth + 'px',
          'max-width': inviteMaxWidth,
          height: inviteData.inviteHeight + 'px',
          'max-height': inviteMaxHeight,
          display: 'block',
          transform: inviteTransform,
        }, true /* important */);
      }

      //invite form modal style
      var inviteIframe = document.getElementById('kampyleInvite');
      if (inviteIframe) {
        KAMPYLE_UTILS.setElementStyle(inviteIframe, {
          width: inviteData.inviteWidth + 'px',
          'max-width': inviteMaxWidth,
          height: inviteData.inviteHeight + 'px',
          'max-height': inviteMaxHeight,
          display: 'block',
          visibility: KAMPYLE_DATA.isNewMobileInvitation() ? 'hidden' : 'visible',
        }, true /* !important */);
      }
    }
    return true;
  }

	function prepareHostingDOM() {
		if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_SPA_OVERFLOW_FIX) && !KAMPYLE_DATA.getMemoryData('isOriginalHostingDom')) {
			return;
		}
		KAMPYLE_DATA.setMemoryData('isOriginalHostingDom', false);
		if (KAMPYLE_DATA.isMobileDynamicSizing()) {
			KAMPYLE_VIEW.manipulateAriaHiddens();
			KAMPYLE_DATA.setMemoryData('hostedBodyOverflowXAttr', document.body.style.overflowX);
			document.body.style.overflowX = 'hidden';
		} else {
			KAMPYLE_DATA.setMemoryData('hostedBodyPositionAttr', document.body.style.position);
			if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_OVERFLOW)) {
				// FIX FOR BANK OF AMERICA, SETTING THE BODY'S OVERFLOW TO HIDDEN BREAKS THEIR UNRESPONSIVE SITE
				return false;
			} else {
				KAMPYLE_DATA.setMemoryData('hostedBodyOverflowAttr', document.body.style.overflow);
        document.body.style.overflow = 'hidden';
			}
		}
	}

	function restoreHostingDOM() {
		if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_SPA_OVERFLOW_FIX)
			&& KAMPYLE_DATA.getMemoryData('isOriginalHostingDom')) {
			return;
		}
		KAMPYLE_DATA.setMemoryData('isOriginalHostingDom', true);
		if (KAMPYLE_DATA.isMobileDynamicSizing()) {
			var modal = document.getElementById('kampyleFormModal');
			KAMPYLE_UTILS.setElementStyle(modal, { height: '100%' }, true /* important */);
			KAMPYLE_VIEW.restoreAriaHidden();
			document.body.style.overflowX = KAMPYLE_DATA.getMemoryData('hostedBodyOverflowXAttr') || '';
		} else {
			if (!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_OVERFLOW)) {
				document.body.style.overflow = KAMPYLE_DATA.getMemoryData('hostedBodyOverflowAttr') || '';
			}
			document.body.style.position = KAMPYLE_DATA.getMemoryData('hostedBodyPositionAttr') || '';
		}
	}


  function createFormContainer(){
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CSP_RULES)){
      MDIGITAL_ELEMENT_BUILDER.createFormContainer();
    } else {
      var formSpanPlacer = KAMPYLE_UTILS.getOrCreateWrapperContainer(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.WRAPPER_ID);
      var html = '';
      html += '<div id="kampyleFormContainer" style="top:0 !important;left:0 !important;width: 100% !important;height: 100% !important;position: fixed !important;visibility:hidden !important;display:table !important;background-color: rgba(102,102,102,0.4) !important;z-index:99999999 !important;-webkit-overflow-scrolling: touch !important; ">';
      html += ' <div id="innerContainer">';
      html += '   <div id="kampyleFormModal" style="z-index:99999999 !important; -webkit-overflow-scrolling: touch !important;"></div>';
      html += ' </div>';
      html += '</div>';
      formSpanPlacer.innerHTML = html;

      var spinnerContainer = MDIGITAL_ELEMENT_BUILDER.createSpinnerElement();
      formSpanPlacer.querySelector('#innerContainer').appendChild(spinnerContainer);
      KAMPYLE_UTILS.setSpinnerStyle(spinnerContainer, KAMPYLE_CONSTANT.SPINNER_SETTINGS.SIZE.LARGE);

      if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_WCAG_PREPEND_SURVEY)) {
        document.body.prepend(formSpanPlacer);
      } else {
        document.body.appendChild(formSpanPlacer);
      }
    }
  }

  //create containers and preload iframe
  //the function create lightBox iframe for Invite and button trigger type,
  //pass the data to createFormIframe
  function handleLightBoxIframe(eventName, data) {
    data = data || {};

    //Load only if not loaded
    var formState = KAMPYLE_DATA.getFormState(data.formId);
    if (formState && formState.loaded || KAMPYLE_FUNC.hasApplicationLoadingFailed(data.formId,false)) { return;}
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var displayType = KAMPYLE_DATA.getDisplayType(formData);

    if (!formData || !data.formId || displayType !== 'lightbox') { return; }

    // TIMEOUT_HANDLERS structure: _memory={ mdTimeoutHandlers: { handlerKey_formId: handlerInstance } }
    var timeoutKey =
      KAMPYLE_CONSTANT.TIMEOUT_HANDLERS.FORM_APP_STATUS + "_" +
      data.formId;
    var timeoutAlreadyCreated = !!KAMPYLE_DATA.getTimeoutHandler(timeoutKey);

    if (!timeoutAlreadyCreated) {
      var appStatusCheck = window.setTimeout(function () {
        if (!KAMPYLE_FUNC.isFormLoaded(data.formId)) {
          KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_FORM_LOADING_HAS_FAILED,
            {
              formId: data.formId,
              failureCause: KAMPYLE_CONSTANT.FORM_LOADING_FAILURE_CAUSE.APPLICATION_FAILED,
              formState: KAMPYLE_DATA.getFormState(data.formId)
            });
        }
      }, KAMPYLE_CONSTANT.NETWORK.TIME_FOR_FORM_TO_LOAD_MS);
      KAMPYLE_DATA.setTimeoutHandler(timeoutKey, appStatusCheck);
    }

    //if we had invitation so we already created container
    if (!document.getElementById('kampyleFormContainer')) {
      createFormContainer();
      //create form container + hide
    }

    // check this element hasnt already been created
    var formIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + data.formId);
    if (!formIframe) {
      var iframeStyleObject = {
        border: 0,
        height: '100%',
        'max-height': '100%',
        'min-height': '100%',
        width: '100%',
        'max-width': '100%',
        'min-width': '100%',
        display: 'none',

      };

      if (!KAMPYLE_DATA.isCustomHtmlForm(data.formId) && !KAMPYLE_DATA.isMobileDynamicSizing(formData.formId)) {
        iframeStyleObject.position = 'fixed';
      }
       var isStyleImportant = true;
       var lightboxContainer = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.CONTAINER_ID_PREFIX);
       KAMPYLE_VIEW.createFormIframe(data.formId,KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX,lightboxContainer,iframeStyleObject,isStyleImportant);

     }
  }

   function createFormIframe(formId, formPrefixId, iframeContainer, iframeStyleObject, isStyleImportant){
      var formData = KAMPYLE_DATA.getFormData(formId);
      var formIframe = document.createElement('iframe');
      KAMPYLE_UTILS.setElementStyle(formIframe,iframeStyleObject,isStyleImportant);
      formIframe.id = formPrefixId + formId;
      var formHtml =  formData.formHtmlUrl;
      formHtml = KAMPYLE_COMMON.createFormUrl(formHtml,formId );
      formIframe.src = formHtml;
      formIframe.tabIndex = -1;
      formIframe.setAttribute('title', KAMPYLE_CONSTANT.IFRAME_SETTINGS.IFRAME_TITLE); //WCAG
      if (KAMPYLE_UTILS.isSafari() && KAMPYLE_UTILS.shouldFocusIframeOnPageShown()) {
        formIframe.setAttribute('aria-label', KAMPYLE_CONSTANT.IFRAME_SETTINGS.IFRAME_TITLE); //WCAG
        formIframe.setAttribute('role', 'dialog'); //WCAG
      }
      iframeContainer.appendChild(formIframe);

      return formIframe
   }


  function applyMobileDynamicStyles(eventName, data) {
    var formId = data.formId;
    var kFormContainer = document.getElementById('kampyleFormContainer');
    if (!(formId && kFormContainer && KAMPYLE_DATA.isMobileDynamicSizing(formId))) { return false; }
    KAMPYLE_UTILS.setElementStyle(kFormContainer, {
      height: KAMPYLE_UTILS.getDocumentSize().height + 'px',
      position: 'absolute',
    }, true /*!important*/);
  }

  function getDefaultIframeHeight() {
    return KAMPYLE_UTILS.isIos() ? '30px' : '100%';
  }

  function iFrameHeightChangedHandler(eventData) {
    if(KAMPYLE_DATA.isLightBoxDisplayType(eventData.formId)){
      var modal = document.getElementById('kampyleFormModal');
      var newHeight = Number((eventData || {}).newHeight);
      newHeight = isNaN(newHeight) ? getDefaultIframeHeight() : (newHeight) + 'px';
      KAMPYLE_UTILS.setElementStyle(modal, { height: newHeight }, true /* force !important */);
    }
  }

  function reactToIframeHeightChange(eventName, eventData) {
    if (KAMPYLE_DATA.isMobileDynamicSizing((eventData || {}).formId)) {
      iFrameHeightChangedHandler(eventData);
      var formHeight = KAMPYLE_UTILS.getNestedPropertyValue(eventData, 'newHeight');
      if (KAMPYLE_VIEW.shouldAddScroll(formHeight)) {
        var kFormContainer = document.getElementById('kampyleFormContainer');
        KAMPYLE_UTILS.setElementStyle(kFormContainer, { overflowY : 'auto'}, true /*isImportant*/);
      }
    }
  }

  function manipulateAriaHiddens() {
    var bodyChilds = document.body.children;
    var ariaHiddenValues = [];
    for (var i = 0; i < bodyChilds.length; i++) {
      ariaHiddenValues.push({
        element: bodyChilds[i],
        prevAriaHiddenValue: bodyChilds[i].getAttribute('aria-hidden'),
      });
      bodyChilds[i].setAttribute('aria-hidden', true);
    }
    KAMPYLE_DATA.setMemoryData('initialAriaHiddenValues', ariaHiddenValues);
  }

  function restoreAriaHidden() {
    var storeValues = KAMPYLE_DATA.getMemoryData('initialAriaHiddenValues') || [];
    for (var i = 0; i < storeValues.length; i++) {
      if (!(storeValues[i].element && storeValues[i].element instanceof Element)) { continue; }
      if (storeValues[i].prevAriaHiddenValue === null) {
        storeValues[i].element.removeAttribute('aria-hidden');
      } else {
        storeValues[i].element.setAttribute('aria-hidden', storeValues[i].prevAriaHiddenValue);
      }
    }
    KAMPYLE_DATA.deleteMemoryData('initialAriaHiddenValues');
  }

  function createInviteIframe(eventName, eventData) {
    var data = KAMPYLE_DATA.getFormData(eventData.formId);
    var inviteSpanPlacer = KAMPYLE_UTILS.getOrCreateWrapperContainer(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.WRAPPER_ID);
    //added spinner
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CSP_RULES)){
      MDIGITAL_ELEMENT_BUILDER.createInviteIframeContainer(data);
    } else {
      var inviteContainerStyles = 'top:0 !important;left:0 !important;width: 100% !important;';
      inviteContainerStyles += 'height: 100% !important;position: fixed !important;visibility:hidden !important;';
      inviteContainerStyles += 'display:none !important;background-color: rgba(22,22,22,0.5) !important;';
      inviteContainerStyles += 'z-index:99999999 !important;overflow:auto !important';
      inviteSpanPlacer.innerHTML = '<div id="kampyleInviteContainer" style="' + inviteContainerStyles + '">' + '<div id="kampyleInviteModal" style="overflow: hidden;margin: 0 auto;height:' + data.inviteData.inviteHeight + ';width:' + data.inviteData.inviteWidth + ';position:relative;z-index:99999999;top: 25%;-webkit-box-shadow:0 0 10px rgba(0,0,0,0.4);-moz-box-shadow:0 0 10px rgba(0,0,0,0.4); box-shadow:0 0 10px rgba(0,0,0,0.4);"></div></div>';

      var spinnerContainer = MDIGITAL_ELEMENT_BUILDER.createSpinnerElement();
      inviteSpanPlacer.querySelector('#kampyleInviteContainer').appendChild(spinnerContainer);
      KAMPYLE_UTILS.setSpinnerStyle(spinnerContainer, KAMPYLE_CONSTANT.SPINNER_SETTINGS.SIZE.LARGE);

      if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_WCAG_PREPEND_SURVEY)) {
        document.body.prepend(inviteSpanPlacer);
      } else {
        document.body.appendChild(inviteSpanPlacer);
      }
    }

    var inviteIframe = document.createElement('iframe');
    inviteIframe.id = KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.IFRAME_ID;
    inviteIframe.title = KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.IFRAME_TITLE;
    inviteIframe.tabIndex = -1;

    var inviteHeight = data.inviteData.inviteHeight;
    var inviteWidth = data.inviteData.inviteWidth;
    var kampyleDevice = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var applyFullscreenStyle = kampyleDevice === KAMPYLE_CONSTANT.DEVICES.MOBILE || kampyleDevice === KAMPYLE_CONSTANT.DEVICES.TABLET;
    var inviteMaxWidth = '100vw';
    var inviteMaxHeight = '100vh';
    var inviteModal = document.getElementById('kampyleInviteModal');
    if (applyFullscreenStyle) {
      inviteHeight = '100%';
      inviteWidth = '100%';

      //Need to change container as well
      if (!!inviteModal)
      {
        KAMPYLE_UTILS.setElementStyle(inviteModal, {
          height: '100%',
          width: '100%',
        }, true);

      }
    }
    if (!!inviteModal) {
      KAMPYLE_UTILS.setElementStyle(inviteModal, {
        maxWidth: inviteMaxWidth,
        maxHeight: inviteMaxHeight,
      }, true);
    }

    KAMPYLE_UTILS.setElementStyle(inviteIframe, {
      height: inviteHeight,
      width: inviteWidth,
      maxWidth: inviteMaxWidth,
      maxHeight: inviteMaxHeight,
      display: 'none',
      border: '0',
    }, true);

    var iframeSrc = data.inviteData.inviteUrl + '?formId=' + eventData.formId;
    if (KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.WCAG)) {
      iframeSrc += '&isWCAG=true';
    }

    iframeSrc += '&domainsListRelativePath=' + KAMPYLE_COMMON.getDomainsListRelativePath(iframeSrc);

    inviteIframe.src = iframeSrc;
    document.getElementById('kampyleInviteModal').appendChild(inviteIframe);


    //Remove spinner for new mobile invitation
    if (KAMPYLE_DATA.isNewMobileInvitation()) {
      var spinner = document.getElementsByClassName('neb-loading-spinner')[0];
      KAMPYLE_UTILS.setElementStyle(spinner, {
        display: 'none',
      }, true /* Important */);

      KAMPYLE_UTILS.setElementStyle(inviteSpanPlacer, {
        'z-index': 99999998,
      }, true /* Important */);

      var inviteContainer = document.getElementById('kampyleInviteContainer');
      if (inviteContainer) {
        KAMPYLE_UTILS.setElementStyle(inviteContainer, {
          'z-index': 99999998,
        }, true /* Important */);
      }
    }

    setTimeout(function(){
      if(KAMPYLE_DATA.getFormState(data.formId).inviteLoaded !== true){
        KAMPYLE_DATA.setFormState(data.formId, {inviteLoaded: false, inviteShown: false});
      }
    }, KAMPYLE_CONSTANT.NETWORK.TIME_FOR_FORM_TO_LOAD_MS);
  }

  function hideButton(eventName, data) {
    if (!data || KAMPYLE_DATA.isEmbeddedDisplayType(data.formId)) {
      return;
    }

    KAMPYLE_VIEW.hideFeedbackButtonVisually();
  }

  function removeButton(eventName, data) {
    var buttonElementById = document.getElementById('kampyleButtonContainer');
    if (!buttonElementById) {
      return;
    }
    buttonElementById.innerHTML = '';

    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FEEDBACK_BUTTON_POSITION_STYLE, {});
  }


  function removeAllShownElements(eventName, data) {
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_SPA_OVERFLOW_FIX)) {
      restoreHostingDOM();
    }
    var lightboxWrapper = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.WRAPPER_ID);
    var invitationWrapper = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.WRAPPER_ID);
    var animationWrapper = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.WRAPPER_ID);
    var abandon = document.getElementById("kampyle_abandon_zone");

    KAMPYLE_VIEW.removeButton(eventName, data);
    KAMPYLE_VIEW.unlistenToResize();

    if (lightboxWrapper) {
      KAMPYLE_UTILS.removeAllContent(lightboxWrapper);
    }
    if (invitationWrapper) {
      KAMPYLE_UTILS.removeAllContent(invitationWrapper);
    }
    if (animationWrapper) {
      KAMPYLE_UTILS.removeAllContent(animationWrapper);
    }
    if (abandon) {
      KAMPYLE_UTILS.removeAllContent(abandon);
    }
  }

  function getButtonText(formData) {
    if (typeof MDIGITAL_LOCALIZATION !== 'undefined' && MDIGITAL_LOCALIZATION.getLocalizedButtonText) {
      return MDIGITAL_LOCALIZATION.getLocalizedButtonText(formData);
    }
    else {
      return formData.buttonData.text;
    }

  }
  /*
    NM-4744 - when body element is in position fixed and provision mobileWebDynamicFormSizeInFormBuilder is enabled,
    then cant scroll down the form
   */
  function shouldAddScroll(formHeight) {
      var bodyPosition = KAMPYLE_UTILS.getElementStyle(document.body, 'position');
      return (bodyPosition === 'fixed' ||  bodyPosition === 'absolute') && (KAMPYLE_UTILS.getDocumentSize().height <= formHeight);
  }

  export default {
    // Only For Testing
    setIframeOrigin: setIframeOrigin,
    ignoreShowForm: ignoreShowForm,
    scrollToEmbeddedForm:scrollToEmbeddedForm,
    scrollFromTop:scrollFromTop,
    doScrollY:doScrollY,
    removeAllShownElements: removeAllShownElements,
    handleLightBoxIframe:handleLightBoxIframe,
    createFormIframe:createFormIframe,
    createFormContainer: createFormContainer,
    showForm: showForm,
    hideForm: hideForm,
    showButton: showButton,
    createButton: createButton,
    listenToResize: listenToResize,
    unlistenToResize: unlistenToResize,
    onResizeButton: onResizeButton,
    debouncedOnResize: debouncedOnResize,
    hideInvite: hideInvite,
    hideButton: hideButton,
    hideFeedbackButtonVisually:hideFeedbackButtonVisually,
    showFeedbackButtonVisually:showFeedbackButtonVisually,
    removeButton: removeButton,
    handleInvitationSkippedForms: handleInvitationSkippedForms,
    updateIframeStyle: updateIframeStyle,
    formatTriangularStyle: formatTriangularStyle,
    formatVerticalStyle: formatVerticalStyle,
    prepareHostingDOM: prepareHostingDOM,
    restoreHostingDOM: restoreHostingDOM,
    getInvitePosition: getInvitePosition,
    newMobileInvite: newMobileInvite,
    changeInviteHeight: changeInviteHeight,
    iFrameHeightChangedHandler: iFrameHeightChangedHandler,
    manipulateAriaHiddens: manipulateAriaHiddens,
    restoreAriaHidden: restoreAriaHidden,
    getDefaultIframeHeight: getDefaultIframeHeight,
    shouldAddScroll: shouldAddScroll,
    shouldShowErrMsgOnForm: shouldShowErrMsgOnForm,
    onErrModalClose: onErrModalClose,
    handleLoadFormEvent: handleLoadFormEvent,
    handleCloseButtonInErroModalKeydown: handleCloseButtonInErroModalKeydown,
    onErrorModalKeyPressed: onErrorModalKeyPressed,
    pickElementStyleProperties: pickElementStyleProperties,
    resetFormState: resetFormState,
    getVerticalButtonTextWidth: getVerticalButtonTextWidth,
    //Public API
    init: init,
    setMetaViewport: setMetaViewport,
    setZIndex: setZIndex,
    showVisibility: showVisibility,
    getCornerMargin: getCornerMargin,
    showFormCouldNotFechtedErrorMsg:showFormCouldNotFechtedErrorMsg,
    handleInviteReady:handleInviteReady,
    getButtonText: getButtonText,
    showInvite: showInvite,
    getWCAGClass: getWCAGClass,
    getClassDirectonByPosition: getClassDirectonByPosition,
    getDynamicButtonStyles: getDynamicButtonStyles,
    getVerticalButtonSize: getVerticalButtonSize,
    getTriangleTextSizeCalculation: getTriangleTextSizeCalculation,
  };
